import * as React from 'react';
import DoomsdayHeader from './DoomsdayHeader';
import DoomsdayGame from './DoomsdayGame';
import DoomsdayStart from './DoomsdayStart';

interface IDoomsdayState {
  started: boolean;
}

export default class Doomsday extends React.Component<{}, IDoomsdayState> {

  constructor(props: {}) {
    super(props);
    this.state = {
      started: false
    }
    this.start = this.start.bind(this);
    this.onEnd = this.onEnd.bind(this);
  }

  public render() {
    return (
      <div className="container">
        <DoomsdayHeader />
        {this.state.started ?
          <DoomsdayGame onEnd={this.onEnd}/>
          :
          <DoomsdayStart start={this.start}/>
        }
      </div>
    );
  }

  private start() {
    this.setState({
      started: true
    });
  }

  private onEnd() {
    this.setState({
      started: false
    })
  }
}



// WEBPACK FOOTER //
// ./src/Doomsday/Doomsday.tsx